export default "__VITE_ASSET__CBXFYZHC__"